import React, { useRef, useState } from 'react';
import { Sun, Sparkles, Shield } from 'lucide-react';

export default function SheerShades() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  
    const whatWeOfferRef = useRef(null); // Reference for the "What We Offer" section
  
    const scrollToSection = () => {
      if (whatWeOfferRef.current) {
        whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
      }
    };
  const gallery = [
    "https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80",
    "https://images.unsplash.com/photo-1513519245088-0e12902e35ca?auto=format&fit=crop&q=80",
    "https://images.unsplash.com/photo-1615529328331-f8917597711f?auto=format&fit=crop&q=80"
  ];
const features = [
  {
    title: "Soft Light Control",
    description:
      "Effortlessly diffuse natural light with sheer fabric layers, creating a warm and inviting ambiance.",
  },
  {
    title: "Elegant Aesthetic",
    description:
      "Sophisticated and modern design enhances any interior with a seamless, stylish look.",
  },
  {
    title: "Enhanced Durability",
    description:
      "Crafted from premium materials to ensure longevity, maintaining beauty and functionality over time.",
  },
  {
    title: "UV Protection",
    description:
      "Filters harmful UV rays while preserving your view and protecting furniture from sun damage.",
  },
  {
    title: "Energy Efficiency",
    description:
      "Helps regulate room temperature by reducing glare and improving insulation for energy savings.",
  },
  {
    title: "Custom Sizing",
    description:
      "Designed to fit your windows perfectly, offering a tailored solution for any space.",
  },
];

  return (
    <div>
      {/* Hero Section */}
      <section 
  className="text-center object-left lg:object-cover min-h-screen flex flex-col pt-40 md:pt-40 lg:pl-32 lg:text-left"
  style={{ backgroundImage: "url('images/sheershades.jpg')" }}
>
  <div className="px-8 sm:px-16 lg:px-24">
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl lg:text-left">
     Sheer 
    </h1>
    <h1 className="text-6xl md:text-8xl 2xl:text-[130px] font-semibold text-[#ffff] font-Montserrat uppercase  mb-4  lg:text-8xl lg:text-left">
      Shades
    </h1>
  </div>

  {/* Button positioned below the text */}
  <div className="mt-4 2xl:mt-6 flex justify-center  lg:pl-52 2xl:pl-60 lg:justify-start">
    <button onClick={scrollToSection} className="text-black bg-[#fff] 2xltext-xl w-40 2xl:w-52 px-6 py-2">
      LEARN MORE
    </button>
  </div>
</section>


 {/* Content Section */}
 <section ref={whatWeOfferRef} className="py-16 px-2 md:px-6 font-playfair">
  <h2 className="text-3xl md:text-5xl lg:text-7xl font-bold text-center mb-10 md:mb-20 ">
  Transform Your Space with <br/>Sheer Shades
  </h2>
  <div  className="flex flex-col gap-20 xl:gap-40 px-4 text-center">
    {/* Benefit 1 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-arround">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8">Wake Up to Gentle Elegance</h3>
        <p className="text-gray-600 text-xl  md:text-2xl xl:text-4xl text-justify">
        Start your day effortlessly with sheer shades that let in natural light at just the right moment. Wake up to a gentle glow as the sunlight filters through, mimicking a peaceful sunrise.
        It’s a refreshing way to begin your day, leaving you feeling energized and ready to take on whatever lies ahead.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] object-fit"
          src="images/sheer.jpg"
          alt="Effortless Morning Comfort"
        />
      </div>
    </div>

    {/* Benefit 2 */}
    <div className="flex flex-col lg:flex-row-reverse gap-20 md:gap-5 items-center justify-between">
      <div className="w-full  max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Subtle Elegance with Sheer Shades</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
        Experience the soft beauty of sheer shades as they diffuse natural light, bringing warmth and tranquility into your home. 
        Create the ideal ambiance effortlessly, whether you're starting your day or unwinding in the evening.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] lg:h-[500px] object-fit"
          src="images/sheer2.jpg"
          alt="Customized Comfort Throughout the Day"
        />
      </div>
    </div>

    {/* Benefit 3 */}
    <div className="flex flex-col lg:flex-row gap-20 md:gap-5 items-center justify-between">
      <div className="w-full max-w-xl xl:max-w-3xl mx-auto">
        <h3 className="text-2xl md:text-5xl xl:text-6xl font-medium mb-8 text-center">Evening Elegance</h3>
        <p className="text-gray-600 text-xl md:text-2xl xl:text-3xl text-justify">
          Create the perfect evening atmosphere with blinds that adjust effortlessly to your desired level of privacy and light. 
          Whether you want a dim, cozy environment for relaxation or a brighter setting for social gatherings, motorized blinds offer versatility for any occasion.
        </p>
      </div>
      <div className="w-full ">
        <img
          className="mx-auto w-full md:w-3/4 xl:w-3/4 h-[300px] md:h-[400px] object-cover"
          src="images/sheer1.jpg"
          alt="Evening Elegance"
        />
      </div>
    </div>
  </div>
</section>

  
{/* Features Section */}

<section className="mb-16 bg-white p-8 max-w-6xl mx-auto xl:pt-20 font-playfair">
  <h2 className="text-3xl md:text-6xl text-center font-semibold text-gray-800 mb-20">
    Key Features of Sheer Shades
  </h2>
  <div>
    {features.map((feature, index) => (
      <div key={index} className="border-b border-gray-400 p-3 mb-4">
        <div
          className="flex justify-between items-center cursor-pointer"
          onClick={() => toggleFAQ(index)}
        >
          <h3 className="text-xl md:text-4xl font-semibold text-gray-800 mb-6">
            {feature.title}
          </h3>
          <button
            className="text-xl md:text-4xl font-bold text-gray-600"
            aria-label="Toggle FAQ"
          >
            {activeIndex === index ? "-" : "+"}
          </button>
        </div>
        {activeIndex === index && (
          <p className="text-gray-600 mt-2 text-base md:text-2xl">
            {feature.description}
          </p>
        )}
      </div>
    ))}
  </div>
</section>;

     
    </div>
  );
}